import { Locale } from 'src/state/Locale';

import enPo from 'src/translations/en.po';
import dePo from 'src/translations/de.po';

export type I18nMessages = {
    readonly [key in Locale]: Record<string, string>;
};

export const I18N_MESSAGES: I18nMessages = {
    en: mapValues(enPo, ([, value]) => value),
    de: mapValues(dePo, ([, value]) => value),
};

function mapValues<TValue, TResult>(
    object: Readonly<Record<string, TValue>>,
    mapper: (value: TValue, key: string) => TResult,
): Record<string, TResult> {
    return Object.keys(object).reduce((result, key) => {
        result[key] = mapper(object[key], key);
        return result;
    }, {} as Record<string, TResult>);
}
